import { mainBoardComponents } from "./mainBoard/navigationComponents";
import { tradesComponents } from "./trades/navigationComponents";
import { orderBookComponents } from "./orderBook/navigationComponents";
import { mainBoardMComponents } from "./mainpanelm/navigationComponents";
import { chartsmobComponents } from "./chartsmob/navigationComponents";
import { orderIndComponents } from "./orderIndicative/navigationComponents";

export const tradingComponents = [...mainBoardComponents, ...tradesComponents, ...orderBookComponents,...mainBoardMComponents,...chartsmobComponents,...orderIndComponents];
